import { render, staticRenderFns } from "./SchedulePractice.vue?vue&type=template&id=632f7124"
import script from "./SchedulePractice.vue?vue&type=script&lang=js"
export * from "./SchedulePractice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports